var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstHoodHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_1170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.097 43.2495C186.097 43.2495 179.518 44.3057 179.518 50.8846C179.518 57.4635 186.097 57.9329 186.097 57.9329",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.643 70.8628V274.381H809.573C809.573 274.381 806.28 215.861 742.127 215.861C742.127 215.861 685.962 214.57 677.263 274.381V299.529H327.691H315.355",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.685 299.523V302.698L315.348 306.461H227.455V268.506C227.455 268.506 228.573 217.628 173.754 193.301C118.934 168.973 47.2013 213.044 47.2013 213.044L41.7339 222.033V244.945L45.7931 244.979L86.5021 245.297C86.5021 245.297 109.414 201.937 161.59 222.205C213.759 242.473 207.242 292.709 207.242 292.709C207.242 292.709 210.825 306.454 227.455 306.454",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6369 248.465H41.0363L24.9998 253.926V280.014H65.5362C65.5362 280.021 76.9061 261.685 76.6369 248.465Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7405 222.033C41.7405 222.033 44.4743 218.774 58.6606 217.801V236.481C58.6606 236.481 52.9309 241.327 41.7405 241.942",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.019 247.409C681.019 247.409 677.318 252.959 675.731 260.277H321.105V247.409H681.019Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.158 253.843H675.731",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.643 212.333H321.106V206.521H943.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.643 179.025H321.106V165.805H943.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.158 172.411H939.059",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.085 145.709H321.106V155.76H943.643",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.348 70.8628V306.454",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.025 306.454V70.8628",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.65 306.454V76.9724H243.553V306.454",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.897 85.0769H300.306V293.765H249.897V85.0769Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.569 70.8628H417.697V145.716H329.569V70.8628Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.262 73.7417H413.99V106.346H333.262V73.7417Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.262 110.93H413.99V142.83H333.262V110.93Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.085 66.7485H182.804",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.441 42.0759V61.64H190.411V42.0759",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.411 61.64L189.617 64.6361H186.09V40.426H190.204V42.069H192.434C196.838 32.7288 205.122 30.4368 205.122 30.4368C230.768 20.3925 317.751 19.3293 317.751 19.3293H931.659C947.64 36.0769 943.643 70.856 943.643 70.856H182.804V56.8698",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.756 73.7417L232.156 86.3748V153.116H188.913L199.959 79.0849H212.177V73.7417H218.756Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.272 150.735H228.863V87.079L215.525 73.7417",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.958 79.0847L197.494 76.9723H193.497L191.426 80.1409H188.092V70.8628",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.178 81.4387V119.98H203.045C201.339 119.98 199.959 118.599 199.959 116.894V84.9042C199.959 82.992 201.512 81.4387 203.424 81.4387H212.178Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.178 123.384V140.773H204.011C201.774 140.773 199.959 138.958 199.959 136.721V126.966C199.959 124.985 201.56 123.384 203.542 123.384H212.178Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.141 151.611H186.711V156.112",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.959 126.966H196.666V162.809H204.246V157.576V156.637H198.606V133.725H199.959V126.966Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.246 157.576L212.475 160.931",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.48 160.931L209.713 165.218L211.356 166.571",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.713 165.218V168.566H220.054V158.639H209.713V160.047",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.666 126.967V85.4912H199.958",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.958 88.2524H198.315V110.93H199.958",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.958 112.987H198.315V126.966",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.666 156.112H173.754V193.301C173.754 193.301 161.328 195.682 161.59 222.205",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5928 138.309V172.853C66.5928 172.853 60.0691 170.029 55.8442 155.581C55.8373 155.581 55.1332 141.746 66.5928 138.309Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.753 156.112C173.753 156.112 90.8165 165.715 61.208 177.264C61.208 177.264 47.4634 179.556 47.2011 213.044",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5928 139.365H68.5327V170.388H66.5928",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6253 171.486V177.699L67.9458 181.02V190.042H65.357V182.373L61.3462 178.362V168.124",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.125 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.365 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.604 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.837 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.077 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.316 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.549 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.789 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.029 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.261 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.501 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.741 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.974 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.213 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.453 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.686 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.925 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.165 173.647V182.463",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 349.89C104.039 349.89 77.1896 323.04 77.1896 289.92C77.1896 256.8 104.039 229.951 137.159 229.951C170.279 229.951 197.128 256.8 197.128 289.92C197.128 323.04 170.279 349.89 137.159 349.89Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 346.735C105.781 346.735 80.3445 321.298 80.3445 289.92C80.3445 258.542 105.781 233.105 137.159 233.105C168.537 233.105 193.974 258.542 193.974 289.92C193.974 321.298 168.537 346.735 137.159 346.735Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 323.76C118.469 323.76 103.319 308.61 103.319 289.92C103.319 271.231 118.469 256.08 137.159 256.08C155.848 256.08 170.999 271.231 170.999 289.92C170.999 308.61 155.848 323.76 137.159 323.76Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 322.242C119.308 322.242 104.837 307.771 104.837 289.92C104.837 272.069 119.308 257.599 137.159 257.599C155.01 257.599 169.48 272.069 169.48 289.92C169.48 307.771 155.01 322.242 137.159 322.242Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 300.938C131.074 300.938 126.141 296.005 126.141 289.92C126.141 283.835 131.074 278.902 137.159 278.902C143.244 278.902 148.177 283.835 148.177 289.92C148.177 296.005 143.244 300.938 137.159 300.938Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.159 303.029C129.918 303.029 124.049 297.16 124.049 289.92C124.049 282.68 129.918 276.811 137.159 276.811C144.399 276.811 150.268 282.68 150.268 289.92C150.268 297.16 144.399 303.029 137.159 303.029Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.793 248.466V244.972",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9655 277.563L76.644 292.177",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.242 292.709H197.135",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4142 347.914C58.6332 348.695 57.3668 348.695 56.5858 347.914L43.8579 335.186C43.0768 334.405 43.0768 333.139 43.8579 332.358C44.6389 331.577 45.9052 331.577 46.6863 332.358L58 343.672L69.3137 332.358C70.0947 331.577 71.3611 331.577 72.1421 332.358C72.9232 333.139 72.9232 334.405 72.1421 335.186L59.4142 347.914ZM56.5858 179.586C57.3668 178.805 58.6332 178.805 59.4142 179.586L72.1421 192.314C72.9232 193.095 72.9232 194.361 72.1421 195.142C71.3611 195.923 70.0947 195.923 69.3137 195.142L58 183.828L46.6863 195.142C45.9052 195.923 44.6389 195.923 43.8579 195.142C43.0768 194.361 43.0768 193.095 43.8579 192.314L56.5858 179.586ZM56 346.5L56 181L60 181L60 346.5L56 346.5Z",
    fill: "#2D9DC9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 349.5,
    x2: 347,
    y2: 349.5,
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_1170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstHoodHeight);
export default __webpack_public_path__ + "static/media/instHoodHeight.b103c50e96c2770d55b99eddb12dd77e.svg";
export { ForwardRef as ReactComponent };